import { useStore } from "vuex";

export default function useCategoryData() {
  const store = useStore();

  async function loadCategoryData(params) {
    const id = params.categoryID;

    await store.dispatch("api/fetchCategory", { id });

    const category = store.getters["api/category"](id);

    await store.dispatch(
      "setPageData",
      { pageName: "Category", data: category },
      { root: true }
    );

    // Side menu and move documents modal need all category docs
    if (!store.getters["api/allCategories"]().length) {
      store.dispatch("api/fetchAllCategories");
    }
  }

  return {
    loadCategoryData,
  };
}
